import React from "react";
import { Link as ChakraLink, LinkProps as ChakraLinkProps } from "@chakra-ui/react";
import { Link, LinkProps as RouterLinkProps } from "react-router-dom";

type CombinedLinkProps = ChakraLinkProps & RouterLinkProps;

export const RouterLink: React.FC<CombinedLinkProps> = (props) => <ChakraLink as={Link} {...props} />;
